/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.SelfCheckInKiosk {

  const config = ($stateProvider: ng.ui.IStateProvider) => {

    const routeName = 'selfCheckInKiosk';
    const contexts = [
      {
        name: routeName + '.login',
        views: {
          pageview: {
            templateUrl: 'app/plugins/selfCheckInKiosk/pages/login/login.html',
            controller: 'meevo.plugins.selfCheckInKiosk.LoginController',
            controllerAs: '$ctrl'
          }
        },
        noun: Meevo.Model.NounEnum.SelfCheckInKioskSearchClientScreen
      },
      {
        name: routeName + '.client-info',
        views: {
          pageview: {
            templateUrl: 'app/plugins/selfCheckInKiosk/pages/client-info/client-info.controller.html',
            controller: 'meevo.plugins.selfCheckInKiosk.ClientInfoController',
            controllerAs: '$ctrl'
          }
        },
        noun: Meevo.Model.NounEnum.SelfCheckInKioskAppointmentService
      },
      {
        name: routeName + '.enhancements',
        views: {
          pageview: {
            templateUrl: 'app/plugins/selfCheckInKiosk/pages/enhancements/enhancements.controller.html',
            controller: 'meevo.plugins.selfCheckInKiosk.EnhancementsController',
            controllerAs: '$ctrl'
          }
        },
        noun: Meevo.Model.NounEnum.SelfCheckInKioskAppointmentServiceAddOn
      },
      {
        name: routeName + '.check-in-success',
        views: {
          pageview: {
            templateUrl: 'app/plugins/selfCheckInKiosk/pages/check-in-success/check-in-success.controller.html',
            controller: 'meevo.plugins.selfCheckInKiosk.CheckInSuccessController',
            controllerAs: '$ctrl'
          }
        },
        noun: Meevo.Model.NounEnum.SelfCheckInKiosk
      },
      {
        name: routeName + '.check-in-fail',
        views: {
          pageview: {
            templateUrl: 'app/plugins/selfCheckInKiosk/pages/check-in-fail/check-in-fail.controller.html',
            controller: 'meevo.plugins.selfCheckInKiosk.CheckInFailController',
            controllerAs: '$ctrl'
          }
        },
        noun: Meevo.Model.NounEnum.SelfCheckInKiosk
      }
    ];

    contexts.forEach((state) => {
      $stateProvider.state(state.name, state);
    });
  };

  config.$inject = [
    '$stateProvider',
  ];

  angular
    .module('meevo.plugins.selfCheckInKiosk', [])
    .config(config);
}
